<router-outlet></router-outlet>
<app-toast></app-toast>
<p-confirm-dialog></p-confirm-dialog>